<template>
    <teleport to="body">
        <div
            class="modal-overlay"
            @mousedown="onOverlayMousedown"
            @click="onOverlayClick"
        >
            <div class="modal-box" :class="{ 'modal-box--wide': wide }">
                <button class="icon-button modal-close" @click="$emit('close')">
                    <span class="material-symbols-outlined">close</span>
                </button>
                <h2 v-if="title" class="modal-title" :title="title">
                    {{ title }}
                </h2>
                <div class="modal-body">
                    <slot />
                </div>
            </div>
        </div>
    </teleport>
</template>

<script>
export default {
    name: "BasicModal",
    props: {
        title: {
            type: String,
            default: "",
        },
        wide: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["close"],
    data() {
        return {
            overlayMousedown: false,
        };
    },
    mounted() {
        document.addEventListener("keydown", this.onKeydown);
    },
    unmounted() {
        document.removeEventListener("keydown", this.onKeydown);
    },
    methods: {
        onKeydown(event) {
            if (event.key === "Escape") {
                this.$emit("close");
            }
        },
        onOverlayMousedown(event) {
            this.overlayMousedown = event.target === event.currentTarget;
        },
        onOverlayClick(event) {
            if (this.overlayMousedown && event.target === event.currentTarget) {
                this.$emit("close");
            }
            this.overlayMousedown = false;
        },
    },
};
</script>
